<template>
    <div class="login">
        <navTop :isLogin="1" title="相君科技平台登录"></navTop>
        <div class="login_accent">
            <div class="login_pent">
                <div class="login-title">
                    <div class="left" :class="isPhone == 0 ? 'active' : ''" @click="handlCheckZhang">账号密码登录</div>
                    <div class="right" :class="isPhone == 1 ? 'active' : ''" @click="handlCheckPhone">手机动态登录</div>
                </div>
                <el-form ref="login" :rules="rules" :model="param">
                    <div class="long_input" v-show="isPhone == 0">
                        <div class="login_userName">
                            <el-form-item prop="userNameM">
                                <el-input maxlength="11" placeholder="请输入手机号" prefix-icon="el-icon-user"
                                          v-model="param.userNameM"
                                          clearable>
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="login_pass">
                            <el-form-item prop="userPassWordM">
                                <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="param.userPassWordM"
                                          clearable
                                          @keyup.enter.native="submitForm()" show-password>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="long_input" v-show="isPhone == 1">
                        <div class="login_userName">
                            <el-input placeholder="请输入手机号" prefix-icon="el-icon-user" v-model="userNameY">
                            </el-input>
                        </div>
                        <div class="login_pass">
                            <el-input placeholder="请输入验证码" prefix-icon="el-icon-lock" v-model="userPassWordY">
                            </el-input>
                        </div>
                    </div>
                    <div class="login_rember">
                        <div class="text" v-show="isPhone == 0">
                            <router-link to="/forgetPass">
                                <span>忘记密码</span>
                            </router-link>
                        </div>
                        <button class="btn" v-if="isPhone == 1" @click="handlCheckGetCode"
                                :disabled="code.status">{{code.text}}
                        </button>
                    </div>
                    <div class="long_btn">
                        <div class="btn" @click="submitForm()">登录</div>
                    </div>
                    <div class="login_regist">
                        <div class="noUser">
                            没有账号
                            <router-link to="/loginRegist">
                                <span>马上注册>></span>
                            </router-link>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>
<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                param: {
                    userNameM: '',
                    userPassWordM: ''
                },
                userNameY: '',
                userPassWordY: '',
                isPhone: 0,
                // rules: {
                //   userNameM: [{
                //     required: true,
                //     message: '请输入用户名',
                //     trigger: 'blur'
                //   }],
                //   userPassWordM: [{
                //     required: true,
                //     message: '请输入密码',
                //     trigger: 'blur'
                //   }],
                // },
                rules: {
                    userNameM: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    userPassWordM: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度应大于等于6个字符小于16个字符!',
                            trigger: "blur"
                        },
                        {
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
                                console.log(passwordreg.test(value))
                                if (!passwordreg.test(value)) {
                                    callback(new Error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'))
                                } else {
                                    callback()
                                }
                            }
                        },
                    ],
                },
                code: {
                    text: '获取验证码',
                    status: false,
                    value: ''
                },

            }
        },

        methods: {

            handlCheckZhang() {
                this.isPhone = 0;
            },
            handlCheckPhone() {
                this.isPhone = 1;
            },
            handlCheckGetCode() {
                this.code.status = true;
                let countdown = 60;
                if (this.xm.isPhone(this.userNameY)) {
                    let _this = this;
                    let param = new URLSearchParams();
                    param.append('phone', _this.userNameY);
                    param.append('type', '1');
                    _this.api.sendCodeToPhone(param).then(res => {
                        console.log(res)
                        if (res.code == 0) {
                            _this.$message.success('发送成功');
                            _this.code.text = countdown + '秒';
                            _this.code.status = true;
                            let timer = setInterval(() => {
                                if (countdown > 0) {
                                    _this.code.text = countdown - 1 + '秒';
                                    countdown--;
                                } else {
                                    clearInterval(timer);
                                    _this.code.text = '获取验证码';
                                    _this.code.status = false;
                                }
                            }, 1000);
                        } else {
                            _this.code.status = false;
                            _this.$message.error(res.msg)
                        }
                    })
                } else if (this.xm.isEmail(this.userNameY)) {
                    let _this = this;
                    let param = new URLSearchParams();
                    param.append('email', this.userNameY);
                    param.append('type', '0');
                    _this.api.sendCodeToEmail(param).then(res => {
                        console.log(res);
                        _this.$message.success('发送成功');
                        _this.code.text = countdown + '秒';
                        _this.code.status = true;
                        let timer = setInterval(() => {
                            if (countdown > 0) {
                                _this.code.text = countdown - 1 + '秒';
                                countdown--;
                            } else {
                                clearInterval(timer);
                                _this.code.text = '获取验证码';
                                _this.code.status = false;
                            }
                        }, 1000);
                    })
                } else {
                    this.code.status = false;
                    this.$message.error('手机号格式错误')
                }

            },
            submitForm() {
                let _this = this;
                if (this.isPhone == 0) {
                    _this.$refs.login.validate(valid => {
                        if (!_this.xm.isPhone(_this.param.userNameM)) {
                            _this.$message.error('请输入正确手机号');
                        } else {
                            if (valid) {
                                let param = new URLSearchParams();
                                param.append('password', _this.param.userPassWordM);
                                param.append('username', _this.param.userNameM);
                                _this.api.clientLogin(param).then(res => {
                                    console.log(res)

                                    if (res.code == 0) {
                                        _this.$message.success('登录成功');
                                        _this.$global.token = res.data.token;
                                        _this.$global.webData = res.data.member;
                                        localStorage.setItem('login', 1);
                                        localStorage.setItem("lastTime", new Date().getTime());
                                        _this.$store.store.commit('handleUserData', res.data.member);
                                        this.$store.store.commit('handleUserToken', res.data.token);

                                        _this.$router.push({
                                            path: '/loginMenu'//
                                        })
                                    } else {
                                        _this.$message.error(res.msg);
                                    }
                                })

                            } else {
                                _this.$message.error('请输入账号或密码');
                                return false;
                            }
                        }

                    });
                } else {
                    if (_this.xm.isPhone(_this.userNameY)) {
                        let param = new URLSearchParams();
                        param.append('code', _this.userPassWordY);
                        param.append('phone', _this.userNameY);
                        _this.api.phoneCodeLogin(param).then(res => {
                            console.log(res);
                            _this.$message.success('登录成功');
                            _this.$global.token = res.data.token;
                            _this.$global.webData = res.data.member;
                            localStorage.setItem('login', 1);
                            localStorage.setItem("lastTime", new Date().getTime());
                            _this.$store.store.commit('handleUserData', res.data.member);
                            this.$store.store.commit('handleUserToken', res.data.token);

                            _this.$router.push({
                                path: '/loginMenu'
                            })
                        })
                    } else if (_this.xm.isEmail(_this.userNameY)) {
                        let param = new URLSearchParams();
                        param.append('code', _this.userPassWordY);
                        param.append('email', _this.userNameY);

                        console.log(this.userNameY, this.userPassWordY)
                        _this.api.emailCodeLogin(param).then(res => {
                            console.log(res);
                            _this.$message.success('登录成功');
                            _this.$global.token = res.data.token;
                            _this.$global.webData = res.data.member;
                            localStorage.setItem('login', 1);
                            localStorage.setItem("lastTime", new Date().getTime());
                            _this.$store.store.commit('handleUserData', res.data.member);
                            this.$store.store.commit('handleUserToken', res.data.token);

                            _this.$router.push({
                                path: '/loginMenu'
                            })
                        })
                    } else {
                        _this.$message.error('请完整输入');
                    }

                }
            }

        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    /deep/ .el-input__inner {
        height: 60px;
        line-height: 60px;
    }

    a {
        text-decoration: none;
    }

    .login {
        width: @a;
        height: @a;

        .login_accent {
            width: @a;
            height: 700px;
            @row();

            .login_pent {
                width: 760px;
                height: 630px;
                border: solid 1px #aaaaaa;

                .login-title {
                    width: @a;
                    height: 80px;
                    display: @flex;

                    .left {
                        width: 50%;
                        height: 80px;
                        margin: -1px;
                        background-color: #fff;
                        border: solid 1px #aaaaaa;
                        font-family: MicrosoftYaHei;
                        font-size: 30px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 2px;
                        color: #333333;
                        line-height: 80px;
                        text-align: center;
                        cursor: pointer;
                    }

                    .right {
                        width: 51%;
                        height: 80px;
                        background-color: #fff;
                        border: solid 1px #aaaaaa;
                        margin: -1px;
                        font-family: MicrosoftYaHei;
                        font-size: 30px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 2px;
                        color: #333333;
                        line-height: 80px;
                        text-align: center;
                        cursor: pointer;
                    }

                    .active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#fff,
                        #fff);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        color: #fff;
                    }
                }

                .long_input {
                    width: @a;
                    height: auto;
                    @column();

                    .login_userName {
                        width: 520px;
                        height: 60px;
                        background-color: #fff;
                        margin-top: 80px;
                    }

                    .login_pass {
                        width: 520px;
                        height: 60px;
                        background-color: #fff;
                        margin-top: 40px;
                    }
                }

                .login_rember {
                    width: @a;
                    height: 100px;
                    display: flex;
                    justify-content: center;
                    position: relative;

                    .text {
                        width: 520px;
                        height: 100px;
                        line-height: 100px;
                        text-align: end;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;

                        span {
                            cursor: pointer;
                        }
                    }

                    .btn {
                        width: 130px;
                        height: 40px;
                        background-color: #fff;
                        border: solid 1px #aaaaaa;
                        line-height: 40px;
                        text-align: center;
                        position: absolute;
                        right: 120px;
                        bottom: 20px;
                        cursor: pointer;
                    }
                }

                .long_btn {
                    width: @a;
                    height: 80px;
                    display: @flex;
                    justify-content: center;
                    cursor: pointer;

                    .btn {
                        width: 520px;
                        height: 80px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        text-align: center;
                        line-height: 80px;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #ffffff;
                    }
                }

                .login_regist {
                    width: @a;
                    height: 30px;
                    margin-top: 50px;
                    @row();

                    .noUser {
                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                        color: #333333;

                        span {
                            font-family: MicrosoftYaHei;
                            font-size: 18px;
                            font-weight: normal;
                            letter-spacing: 1px;
                            color: #1e6eee;
                            cursor: pointer;
                        }
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/login/login.vue